import React, { useContext, useEffect, useReducer, useMemo } from 'react'

import { Box, IconButton } from '@mui/material'
import { api } from '../../../services/api';
import toast from 'react-hot-toast'
import { getSession } from '../../../contexts/auth';
import { lockedReducer } from '../../Utils/reducers';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { externalComponent } from '../../AppRoutes';
import Table, { TableHook } from '../../Table';
import EditAcesso from './edit';

const url = '/acessos/'

const submitDelete = async (data, setState, getData, setLoader) => {
    setLoader(true)
    const res = await api.delete(`${url}${data.id}/`)
    setLoader(false)
    if (res.status === 200) {
        toast.success('Deletado com sucesso')
        setState({ deleteRow: false })
        getData()
        return
    }else{
        toast.error(res.data.detail)
    }

}

const columns = (setState, permissions) => {
    return [
        { field: 'id', headerName: 'ID', flex: 1, filterType: 'string' },
        { field: 'nome', headerName: 'Nome', flex: 1, filterType: 'string' },
        {
            field: 'actions', headerName: 'Ações', filterable: false,
            renderCell: (props) => {
                return (
                    <Box >
                        {<IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton>}
                        {<IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton>}
                    </Box>
                )
            }
        }
    ]
}



const Acesso = () => {

    const { setLoader } = useContext(externalComponent)
    
    const user = getSession()

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        permissions: [],
        editRow: null,
        deleteRow: null
    })

    useEffect(() => {
      
    }, [setLoader])

    const [table, reloadTable] = TableHook()

    const reloadData = () => {
        reloadTable()
    }
    

    return(
        <>
            {state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir o acesso ${state.deleteRow.nome}?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => submitDelete(state.deleteRow, setState, reloadData, setLoader)}
                />
            }

            {state.editRow &&
                <EditAcesso
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={reloadData}
                    permissions={state.permissions}
                    setLoader={setLoader}
                />
            }
           
            <Box className='information-table'>
                <Box className='user-table'>
                    <Table
                        rows={state.rows}
                        columns={useMemo(()=> columns(setState))}
                        pagination
                        density='compact'
                        toolbar
                        slots={{
                            returnComponent: ()=> window.backtobase(),
                            addComponent: () => setState({ editRow: {} })
                        }}
                        getURL={url}
                        updateRows={(rows) => setState({'rows': rows})}
                        innerRef={table}
                    />
                </Box>
            </Box>
        
        </>
    )
}

export default Acesso;